import React from "react";
import ArticleCard from "./ArticleCard";

export default function BlogsPostCard(props) {
  return <ArticleCard blog={props.blog} className="col-md-6 col-sm-12 d-flex" />;
}
